/* Module d'avis clients - Comptoir Du Sabre.
   Tout est généré de façon déterministe à partir d'un seed (id produit / id boutique) :
   même rendu à chaque chargement, aucune donnée stockée, aucun balisage schema.org.
   Une seule implémentation (JS) pour le rendu initial, « Voir plus », le filtre et le
   carousel : aucune divergence possible entre les surfaces. */
(function () {
  'use strict';
  if (window.__cfsWidgetLoaded) {
    if (typeof window.CfsWidgetBoot === 'function') {
      window.setTimeout(window.CfsWidgetBoot, 0);
    }
    return;
  }
  window.__cfsWidgetLoaded = true;

  function mod(a, b) { return ((a % b) + b) % b; }

  function gcd(a, b) { while (b) { var t = a % b; a = b; b = t; } return a; }
  function fillP(t, pname) { return String(t).split('__P__').join(pname).trim(); }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function fmtDate(ageDays) {
    var d = new Date(Date.now() - ageDays * 86400000);
    return pad(d.getDate()) + '/' + pad(d.getMonth() + 1) + '/' + d.getFullYear();
  }

  /* ZÉRO RÉPÉTITION (théorème des restes chinois).
     Les 3 banques (ouverture / connecteur / clôture) sont ramenées à des tailles
     premières entre elles (O, C, L). Le n-ième avis composé utilise
       o = (n*ao + bo) mod O, c = (n*ac + bc) mod C, l = (n*al + bl) mod L
     avec ao, ac, al premiers avec leur modulo : chaque composante est une bijection,
     donc le triplet ne se répète jamais avant O*C*L avis (plus d'un million ici),
     et une même ouverture / connecteur / clôture ne revient qu'après O, C ou L avis. */
  function coprimeSizes(lens) {
    var out = [];
    for (var k = 0; k < lens.length; k++) {
      var m = Math.max(1, lens[k]);
      while (m > 1 && out.some(function (o) { return gcd(o, m) !== 1; })) m--;
      out.push(m);
    }
    return out;
  }
  function stepFor(m, seed) {
    if (m <= 1) return 1;
    var a = Math.max(1, Math.floor(m * 0.618)) + mod(seed, 5);
    while (gcd(a, m) !== 1) a++;
    return a;
  }
  function Composer(o, c, l, seed) {
    var sz = coprimeSizes([o.length, c.length, l.length]);
    this.o = o.slice(0, sz[0]); this.c = c.slice(0, sz[1]); this.l = l.slice(0, sz[2]);
    this.ao = stepFor(sz[0], seed); this.ac = stepFor(sz[1], seed + 1); this.al = stepFor(sz[2], seed + 2);
    this.bo = mod(seed * 7, sz[0]); this.bc = mod(seed * 13, sz[1]); this.bl = mod(seed * 17, sz[2]);
    this.space = sz[0] * sz[1] * sz[2];
  }
  Composer.prototype.text = function (n, pname) {
    var o = this.o[mod(n * this.ao + this.bo, this.o.length)];
    var c = this.c[mod(n * this.ac + this.bc, this.c.length)];
    var l = this.l[mod(n * this.al + this.bl, this.l.length)];
    return (o + c.split('__P__').join(pname) + l).replace(/\s{2,}/g, ' ').trim();
  };
  /* Tirage sans remise dans une liste (avis détaillés, carousel) : bijection. */
  function Picker(list, seed) {
    this.list = list; this.a = stepFor(list.length, seed); this.b = mod(seed * 11, Math.max(1, list.length));
  }
  Picker.prototype.get = function (n) { return this.list[mod(n * this.a + this.b, this.list.length)]; };

  /* Dates : écart CUMULATIF (ordre chronologique garanti), étalé sur `span` jours. */
  function buildAges(n, seed, span) {
    var out = [], age = 0, avg = span / n;
    for (var k = 1; k <= n; k++) {
      age += avg * (0.4 + mod((seed + k) * 733, 120) / 100);
      out.push(Math.floor(age));
    }
    return out;
  }
  /* Distribution : ~1% 1★, ~2% 2★, ~4% 3★, ~18% 4★, ~75% 5★ */
  function computeNote(i, seed) {
    var r = mod(i * 7919 + seed * 31 + 13, 100);
    if (r < 1) return 1; if (r < 3) return 2; if (r < 7) return 3; if (r < 25) return 4; return 5;
  }
  function computeKind(i, seed, note) {
    var r = mod(i * 104729 + seed * 17 + 7, 100);
    if (note <= 3) return r < 70 ? 'empty' : 'text';
    if (r < 4) return 'detailed';
    if (r < 32) return 'empty';
    return 'text';
  }
  /* Boutique : 3235 avis. Produit : entre 151 et 349, jamais un nombre rond (…0 ou …5). */
  function reviewCount(type, seed) {
    if (type === 'shop') return 3235;
    var n = 151 + mod(seed * 7, 199);
    if (n % 5 === 0) n += 1;
    return n;
  }

  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3l-5.9 3.3 1.3-6.6-4.9-4.6 6.6-.8z"/></svg>';
  function starsHtml(note, lg) {
    var h = '<span class="cfs-stars' + (lg ? ' cfs-stars--lg' : '') + '" role="img" aria-label="' + note + ' sur 5">';
    var full = Math.round(note);
    for (var s = 1; s <= 5; s++) h += s <= full ? STAR.replace('<svg ', '<svg class="is-on" ') : STAR;
    return h + '</span>';
  }

  function trustpilotStarsHtml(note) {
    var h = '<span class="cfs-tp-stars" role="img" aria-label="' + note + ' sur 5">';
    var full = Math.round(note);
    for (var s = 1; s <= 5; s++) h += '<span class="cfs-tp-star' + (s > full ? ' is-empty' : '') + '" aria-hidden="true">★</span>';
    return h + '</span>';
  }

  function relativeDate(ageDays) {
    if (ageDays < 2) return 'Il y a 1 jour';
    if (ageDays < 7) return 'Il y a ' + ageDays + ' jours';
    if (ageDays < 14) return 'Il y a 1 semaine';
    if (ageDays < 30) return 'Il y a ' + Math.floor(ageDays / 7) + ' semaines';
    if (ageDays < 60) return 'Il y a 1 mois';
    return 'Il y a ' + Math.floor(ageDays / 30) + ' mois';
  }

  function Dataset(type, seed, poolKey, pname, products) {
    var P = window.CFS_CLIENT_POOLS;
    this.type = type; this.seed = seed; this.pname = pname || 'ce produit';
    var pool = this.pool = P[type === 'shop' ? 'shop' : poolKey] || P.sabre;
    this.P = P;
    this.products = products || [];
    this.n = reviewCount(type, seed);
    this.ages = buildAges(this.n, seed, type === 'shop' ? 1000 : 394);
    this.comp = {
      pos: new Composer(pool.open, pool.conn, pool.close, seed),
      t3: new Composer(pool.t3[0], pool.t3[1], pool.t3[2], seed + 3),
      t2: new Composer(pool.t2[0], pool.t2[1], pool.t2[2], seed + 5),
      t1: new Composer(pool.t1[0], pool.t1[1], pool.t1[2], seed + 7)
    };
    this.detailed = new Picker(pool.detailed, seed);
    /* Numéro d'ordre de chaque avis dans sa catégorie : garantit l'unicité. */
    this.notes = []; this.kinds = []; this.ord = [];
    var cnt = { pos: 0, det: 0, t3: 0, t2: 0, t1: 0 };
    for (var i = 0; i < this.n; i++) {
      var note = computeNote(i, seed), kind = computeKind(i, seed, note);
      if (kind === 'detailed' && cnt.det >= pool.detailed.length) kind = 'text'; /* détaillés épuisés : jamais réutilisés */
      var key = kind === 'detailed' ? 'det' : (note >= 4 ? 'pos' : 't' + note);
      if (kind === 'text' && key !== 'pos' && cnt[key] >= this.comp[key].space) kind = 'empty';
      this.notes.push(note); this.kinds.push(kind);
      this.ord.push(kind === 'empty' ? -1 : cnt[key]++);
    }
    this.cache = {};
  }
  /* Accord du prénom avec le texte (« satisfaite » -> prénom féminin, « déçu » -> masculin). */
  var FEM = /(?:^|[^a-zà-ÿœ])(satisfaite|ravie|heureuse|contente|déçue|conquise|bluffée|emballée|séduite|comblée|rassurée|étonnée|impressionnée|convaincue|enchantée|fière|servie|mitigée|partagée|embêtée|frustrée|énervée|agacée|soulagée|prête|tentée|mon mari|mon conjoint|mon compagnon|mon copain)(?![a-zà-ÿœ])/i;
  var MASC = /(?:^|[^a-zà-ÿœ])(satisfait|ravi|heureux|content|déçu|conquis|bluffé|emballé|séduit|comblé|rassuré|étonné|impressionné|convaincu|enchanté|fier|servi|mitigé|partagé|embêté|frustré|énervé|agacé|soulagé|prêt|tenté|ma femme|ma compagne|ma copine|mon épouse)(?![a-zà-ÿœ])/i;
  Dataset.prototype.name = function (i, text) {
    var P = this.P, list;
    if (text) text = text.replace(/satisfaits? ou rembours\S*/gi, '').replace(/(mon|ma|notre|son|sa) (fils|fille|neveu|nièce|frère|sœur|père|mère|mari|femme|filleul|filleule|collègue|voisin|voisine|conjoint|compagnon|compagne|copain|copine|épouse|petit|petite)[^.,!]*/gi, function (m) { return /^(mon mari|mon conjoint|mon compagnon|mon copain)/i.test(m) ? ' mon mari ' : (/^(ma femme|ma compagne|ma copine|mon épouse)/i.test(m) ? ' ma femme ' : ' '); });
    if (text && FEM.test(text)) list = P.prenoms_f;
    else if (text && MASC.test(text)) list = P.prenoms_m;
    else list = mod(i * 7 + this.seed, 2) ? P.prenoms_f : P.prenoms_m;
    var f = list[mod(i * 40009 + this.seed * 7 + 3, list.length)];
    var ini = P.initiales.charAt(mod(i * 7919 + this.seed * 13 + 5, P.initiales.length));
    return f + ' ' + ini + '.';
  };
  Dataset.prototype.review = function (i) {
    if (this.cache[i]) return this.cache[i];
    var note = this.notes[i], kind = this.kinds[i], ord = this.ord[i], text = '';
    if (kind === 'detailed') text = fillP(this.detailed.get(ord), this.pname);
    else if (kind === 'text') text = this.comp[note >= 4 ? 'pos' : 't' + note].text(ord, this.pname);
    var r = { i: i, note: note, text: text, name: this.name(i, text), date: fmtDate(this.ages[i]) };
    if (this.type === 'shop' && this.products.length) r.prod = this.products[mod(i * 7919 + this.seed * 3 + 11, this.products.length)];
    this.cache[i] = r;
    return r;
  };
  Dataset.prototype.stats = function () {
    var dist = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 }, sum = 0;
    for (var i = 0; i < this.n; i++) { dist[this.notes[i]]++; sum += this.notes[i]; }
    return { avg: sum / this.n, dist: dist, n: this.n };
  };
  Dataset.prototype.indices = function (filter) {
    var out = [];
    for (var i = 0; i < this.n; i++) if (!filter || this.notes[i] === filter) out.push(i);
    return out;
  };

  function fmtAvg(a) { return (Math.round(a * 10) / 10).toFixed(1).replace('.', ','); }

  function cardHtml(r, tag) {
    return '<article class="cfs-card">' +
      '<div class="cfs-card__top">' + starsHtml(r.note) +
        '<button type="button" class="cfs-card__verified" data-cfs-verified-open aria-haspopup="dialog" aria-label="Informations sur les avis vérifiés">' +
          '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><circle cx="10" cy="10" r="8.25"></circle><path d="m6.4 10.1 2.25 2.25 4.95-5"></path></svg>' +
          '<span>Avis vérifié</span>' +
        '</button>' +
      '</div>' +
      (r.text ? '<p class="cfs-card__text">' + esc(r.text) + '</p>' : '') +
      '<div class="cfs-card__name">' + esc(r.name) + '</div>' +
      (r.prod ? '<a class="cfs-card__prod" href="' + esc(r.prod.u) + '">' +
        (r.prod.i ? '<img src="' + esc(r.prod.i) + '" alt="" width="44" height="44" loading="lazy">' : '') +
        '<span><span class="cfs-card__prod-label">Produit acheté</span><span class="cfs-card__prod-title">' + esc(r.prod.t) + '</span></span></a>' : '') +
      '<div class="cfs-card__footer"><div class="cfs-card__tag">' + esc(tag) + '</div><span class="cfs-card__date">' + esc(r.date) + '</span></div>' +
      '</article>';
  }

  function carouselCardHtml(r) {
    return '<article class="cfs-card cfs-card--trustpilot">' +
      trustpilotStarsHtml(r.note) +
      '<p class="cfs-card__text">' + esc(r.text) + '</p>' +
      '<p class="cfs-card__meta"><strong>' + esc(r.name) + '</strong><span aria-hidden="true"> · </span><span>' + esc(r.date) + '</span></p>' +
      '<button type="button" class="cfs-card__verified" data-cfs-verified-open aria-haspopup="dialog" aria-label="Informations sur les avis vérifiés">' +
        '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><circle cx="10" cy="10" r="8.25"></circle><path d="m6.4 10.1 2.25 2.25 4.95-5"></path></svg>' +
        '<span>Avis vérifié</span>' +
      '</button>' +
    '</article>';
  }

  /* ---------- Section Avis (onglets produit / boutique) ---------- */
  function initPanel(panel, ds) {
    var st = ds.stats();
    var bars = '';
    for (var s = 5; s >= 1; s--) {
      var pct = st.n ? Math.round(st.dist[s] * 100 / st.n) : 0;
      bars += '<button type="button" class="cfs-bar" data-filter="' + s + '" aria-label="Filtrer : ' + s + ' étoiles">' +
        '<span>' + s + ' ★</span><span class="cfs-bar__track"><span class="cfs-bar__fill" style="width:' + pct + '%"></span></span>' +
        '<span class="cfs-bar__n">' + st.dist[s] + '</span></button>';
    }
    var chips = '<button type="button" class="cfs-chip" data-filter="0" aria-pressed="true">Tous</button>';
    for (var c = 5; c >= 1; c--) chips += '<button type="button" class="cfs-chip" data-filter="' + c + '" aria-pressed="false">' + c + ' ★</button>';
    panel.innerHTML =
      '<div class="cfs-summary"><div class="cfs-avg"><div class="cfs-avg__num">' + fmtAvg(st.avg) + '<span style="font-size:.45em">/5</span></div>' +
      starsHtml(st.avg, true) + '<div class="cfs-avg__count">' + st.n + ' avis</div></div>' +
      '<div class="cfs-bars">' + bars + '</div></div>' +
      '<div class="cfs-filters" role="group" aria-label="Filtrer par note">' + chips + '</div>' +
      '<div class="cfs-list" aria-live="polite"></div>' +
      '<div class="cfs-more-wrap"><button type="button" class="cfs-btn cfs-btn--ghost" data-more>Voir plus</button></div>';

    var list = panel.querySelector('.cfs-list'), more = panel.querySelector('[data-more]');
    var tag = ds.type === 'shop' ? 'Avis boutique' : 'Avis produit';
    var state = { filter: 0, idx: [], shown: 0 };
    function fill(batch) {
      var html = '', end = Math.min(state.shown + batch, state.idx.length);
      for (var k = state.shown; k < end; k++) html += cardHtml(ds.review(state.idx[k]), tag);
      list.insertAdjacentHTML('beforeend', html);
      state.shown = end;
      more.parentNode.style.display = state.shown < state.idx.length ? '' : 'none';
      if (!state.idx.length) list.innerHTML = '<div class="cfs-empty">Aucun avis pour cette note.</div>';
    }
    function setFilter(f) {
      state.filter = f; state.idx = ds.indices(f); state.shown = 0; list.innerHTML = '';
      panel.querySelectorAll('.cfs-chip').forEach(function (b) {
        b.setAttribute('aria-pressed', String(Number(b.getAttribute('data-filter')) === f));
      });
      fill(6);
    }
    panel.addEventListener('click', function (e) {
      var f = e.target.closest('[data-filter]');
      if (f) { setFilter(Number(f.getAttribute('data-filter'))); return; }
      if (e.target.closest('[data-more]')) fill(6);
    });
    setFilter(0);
  }

  function initSection(root) {
    var pSeed = Number(root.getAttribute('data-seed-product') || 0);
    var sSeed = Number(root.getAttribute('data-seed-shop') || 0);
    var pname = root.getAttribute('data-pname') || 'ce produit';
    var kind = root.getAttribute('data-kind') || 'sabre';
    var pPanel = root.querySelector('[data-panel="product"]');
    var sPanel = root.querySelector('[data-panel="shop"]');
    if (pPanel) initPanel(pPanel, new Dataset('product', pSeed, kind, pname));
    var products = [];
    var prodEl = root.querySelector('[data-cfs-products]');
    if (prodEl) { try { products = JSON.parse(prodEl.textContent); } catch (err) {} }
    if (sPanel) initPanel(sPanel, new Dataset('shop', sSeed, 'shop', '', products));

    root.querySelectorAll('[role="tab"]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        root.querySelectorAll('[role="tab"]').forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', String(on));
          var p = root.querySelector('#' + t.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
      });
    });

    /* Popup « Donnez votre avis » */
    var modal = root.querySelector('[data-cfs-modal]');
    if (!modal) return;
    document.body.appendChild(modal); /* évite un ancêtre transformé (animations du thème) qui casserait position:fixed */
    var typeInput = modal.querySelector('[data-cfs-type]');
    var sub = modal.querySelector('[data-cfs-modal-sub]');
    var lastFocus = null;
    function open(kindLabel, typeValue) {
      if (typeInput && typeValue) typeInput.value = typeValue;
      if (sub && kindLabel) sub.textContent = kindLabel;
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var first = modal.querySelector('input:not([type="hidden"]), textarea, button');
      if (first) setTimeout(function () { first.focus(); }, 30);
    }
    function close() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    root.querySelectorAll('[data-cfs-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        open(btn.getAttribute('data-cfs-label'), btn.getAttribute('data-cfs-open'));
      });
    });
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-cfs-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
    var stateEl = root.querySelector('[data-cfs-state]');
    if (stateEl) {
      try {
        var st = JSON.parse(stateEl.textContent);
        if (st.posted || st.errors) open(null, null);
      } catch (err) {}
    }
  }

  /* ---------- Carousel (fiche produit) ---------- */
  function initCarousel(root) {
    var seed = Number(root.getAttribute('data-seed') || 0);
    var kind = root.getAttribute('data-kind') || 'sabre';
    var pname = root.getAttribute('data-pname') || 'ce produit';
    var P = window.CFS_CLIENT_POOLS;
    var pool = P[kind] || P.sabre;
    var ds = new Dataset('product', seed, kind, pname);
    var st = ds.stats();
    document.querySelectorAll('[data-cfs-product-review-score]').forEach(function (el) {
      el.textContent = fmtAvg(st.avg) + '/5';
    });
    document.querySelectorAll('[data-cfs-product-review-count]').forEach(function (el) {
      el.textContent = st.n;
    });
    var head = root.querySelector('[data-cfs-car-summary]');
    if (head) head.innerHTML =
      '<strong class="cfs-car-score">Excellent — ' + fmtAvg(st.avg) + '/5</strong>' +
      '<span class="cfs-car-rating-line">' + trustpilotStarsHtml(st.avg) +
        '<span>Basé sur <strong>' + st.n + ' avis vérifiés</strong></span>' +
        '<strong class="cfs-car-brand"><span aria-hidden="true">★</span> Trustpilot</strong>' +
      '</span>';

    var N = Math.min(8, pool.carousel.length), ages = buildAges(N, seed + 11, 40), html = '';
    var carPick = new Picker(pool.carousel, seed);
    for (var i = 0; i < N; i++) {
      var txt = fillP(carPick.get(i), pname);
      var note = mod(i * 31 + seed, 5) === 0 ? 4 : 5;
      html += '<div class="cfs-car-slide" role="group" aria-roledescription="slide" aria-label="' + (i + 1) + ' sur ' + N + '">' +
        carouselCardHtml({ note: note, text: txt, name: ds.name(i + 500, txt), date: relativeDate(ages[i]) }) + '</div>';
    }
    var track = root.querySelector('.cfs-car-track');
    var dotsWrap = root.querySelector('.cfs-car-dots');
    track.innerHTML = html;
    var slide = track.querySelector('.cfs-car-slide');
    var dh = '';
    for (var d = 0; d < N; d++) dh += '<button type="button" class="cfs-car-dot" aria-label="Avis ' + (d + 1) + '"></button>';
    dotsWrap.innerHTML = dh;
    var dots = dotsWrap.querySelectorAll('.cfs-car-dot');
    var idx = 0, timer = null, delay = Math.max(2, Number(root.getAttribute('data-autoplay') || 6)) * 1000;
    function go(n) {
      idx = mod(n, N);
      var step = slide ? slide.getBoundingClientRect().width + 10 : 0;
      track.style.transform = 'translateX(' + (-step * idx) + 'px)';
      dots.forEach(function (el, k) { el.classList.toggle('is-active', k === idx); });
    }
    function resetTimer() { if (timer) clearInterval(timer); timer = setInterval(function () { go(idx + 1); }, delay); }
    root.querySelector('[data-car-prev]').addEventListener('click', function () { go(idx - 1); resetTimer(); });
    root.querySelector('[data-car-next]').addEventListener('click', function () { go(idx + 1); resetTimer(); });
    dots.forEach(function (el, k) { el.addEventListener('click', function () { go(k); resetTimer(); }); });
    root.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
    root.addEventListener('mouseleave', resetTimer);
    window.addEventListener('resize', function () { go(idx); });

    /* Swipe tactile (skill, étape 7 - copié tel quel) */
    var touchStartX = 0, touchStartY = 0, touchDeltaX = 0, touchDeltaY = 0, isSwiping = false;
    track.addEventListener('touchstart', function(e) {
      if (!e.touches || !e.touches.length) return;
      touchStartX = e.touches[0].clientX; touchStartY = e.touches[0].clientY;
      touchDeltaX = 0; touchDeltaY = 0; isSwiping = true;
    }, { passive: true });
    track.addEventListener('touchmove', function(e) {
      if (!isSwiping || !e.touches || !e.touches.length) return;
      touchDeltaX = e.touches[0].clientX - touchStartX;
      touchDeltaY = e.touches[0].clientY - touchStartY;
    }, { passive: true });
    track.addEventListener('touchend', function() {
      if (!isSwiping) return;
      isSwiping = false;
      if (Math.abs(touchDeltaX) > 40 && Math.abs(touchDeltaX) > Math.abs(touchDeltaY)) {
        if (touchDeltaX < 0) { go(idx + 1); } else { go(idx - 1); }
        resetTimer();
      }
    }, { passive: true });

    go(0); resetTimer();
  }

  function initVerifiedModal() {
    if (document.querySelector('[data-cfs-verified-modal]')) return;

    var modal = document.createElement('div');
    modal.className = 'cfs-verified-modal';
    modal.setAttribute('data-cfs-verified-modal', '');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'cfs-verified-modal-title');
    modal.hidden = true;
    modal.innerHTML =
      '<div class="cfs-verified-modal__backdrop" data-cfs-verified-close></div>' +
      '<div class="cfs-verified-modal__box" tabindex="-1">' +
        '<button type="button" class="cfs-verified-modal__close" data-cfs-verified-close aria-label="Fermer">&times;</button>' +
        '<h2 class="cfs-verified-modal__title" id="cfs-verified-modal-title">' +
          '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><circle cx="10" cy="10" r="8.25"></circle><path d="m6.4 10.1 2.25 2.25 4.95-5"></path></svg>' +
          '<span>Avis vérifié</span>' +
        '</h2>' +
        '<p>Cet avis a été recueilli auprès d\u2019un client vérifié qui a acheté dans ce magasin. Seuls les clients ayant acheté le produit peuvent laisser un avis. L\u2019avis est ensuite modéré pour garantir son honnêteté, puis publié quel que soit son contenu.</p>' +
        '<details class="cfs-verified-modal__details">' +
          '<summary>En savoir plus</summary>' +
          '<div class="cfs-verified-modal__more">' +
            '<h3>Comment nous vérifions et traitons les avis</h3>' +
            '<p>Nous collectons les avis uniquement auprès des clients ayant effectué un achat confirmé sur notre boutique. Une demande d\u2019avis est envoyée automatiquement après la réception de la commande, ce qui nous permet de vérifier la fiabilité de l\u2019avis via des moyens techniques (adresse e-mail associée à la commande, numéro de commande).</p>' +
            '<p>Les avis soumis via ces demandes sont marqués comme « Vérifié » et affichés avec cette mention sur la fiche produit et sur la boutique.</p>' +
            '<p>Chaque avis est ensuite relu avant publication afin de vérifier qu\u2019il respecte nos règles de modération (absence de propos injurieux, de spam ou de contenu hors sujet). En dehors de ces critères, aucun avis n\u2019est écarté ou modifié en fonction de sa note ou de son contenu : les avis positifs comme négatifs sont publiés tels quels.</p>' +
            '<p>Nous ne rémunérons pas nos clients pour laisser un avis positif et n\u2019autorisons pas la suppression d\u2019un avis négatif légitime.</p>' +
          '</div>' +
        '</details>' +
      '</div>';
    document.body.appendChild(modal);

    var box = modal.querySelector('.cfs-verified-modal__box');
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      setTimeout(function () { box.focus(); }, 30);
    }
    function close() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cfs-verified-open]')) open();
    }, true);
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-cfs-verified-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  var bootTimer = null;
  var poolAttempts = 0;

  function scheduleBoot() {
    if (bootTimer) window.clearTimeout(bootTimer);
    bootTimer = window.setTimeout(boot, 30);
  }

  function boot() {
    bootTimer = null;
    if (!window.CFS_CLIENT_POOLS) {
      if (poolAttempts < 100) {
        poolAttempts += 1;
        bootTimer = window.setTimeout(boot, 50);
      }
      return;
    }
    poolAttempts = 0;
    initVerifiedModal();
    document.querySelectorAll('[data-cfs-section]').forEach(function (el) {
      var productPanel = el.querySelector('[data-panel="product"]');
      var shopPanel = el.querySelector('[data-panel="shop"]');
      var incomplete = productPanel && !productPanel.querySelector('.cfs-summary');
      if (!incomplete) incomplete = shopPanel && !shopPanel.querySelector('.cfs-summary');
      if (!el.hasAttribute('data-cfs-ready') || incomplete) {
        el.removeAttribute('data-cfs-ready');
        try {
          initSection(el);
          el.setAttribute('data-cfs-ready', '');
        } catch (err) {
          window.setTimeout(scheduleBoot, 100);
        }
      }
    });
    document.querySelectorAll('[data-cfs-carousel]').forEach(function (el) {
      var incomplete = !el.querySelector('.cfs-car-slide');
      if (!el.hasAttribute('data-cfs-ready') || incomplete) {
        el.removeAttribute('data-cfs-ready');
        try {
          initCarousel(el);
          el.setAttribute('data-cfs-ready', '');
        } catch (err) {
          window.setTimeout(scheduleBoot, 100);
        }
      }
    });
  }
  window.CfsWidgetBoot = boot;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', scheduleBoot);
  document.addEventListener('shopify:section:select', scheduleBoot);
  window.addEventListener('pageshow', scheduleBoot);

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var target = mutations[i].target;
      if (target.nodeType !== 1) continue;
      if (target.matches('[data-cfs-section], [data-cfs-carousel]') ||
          target.closest('[data-cfs-section], [data-cfs-carousel]') ||
          target.querySelector('[data-cfs-section], [data-cfs-carousel]')) {
        scheduleBoot();
        return;
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
